module.exports = __webpack_public_path__ + "static/media/73070012-ing1wSgs.45849f9e.JPG";